import { get, handleApiError, post } from '@helpers/httpClient';

import { mapUserSubscribeListItem } from '../@mappers/user.mappers';
import { IUserSubscribeListItemDTO } from '../@types/user.types.dto';

export const getSubscribesList = async () => {
  const res = await get('/ajax/users/subscribes/list.php').then<IUserSubscribeListItemDTO[]>(
    handleApiError,
  );

  return res.map(mapUserSubscribeListItem);
};

export const testSubscribeById = async (id: number) => {
  const res = await post('/ajax/users/subscribes/test.php', { id }).then<{ result: any }>(
    handleApiError,
  );

  return res.result;
};

export const getSubscribesPromoInfo = () => {
  return get('/ajax/users/subscribes/promo.php').then<{
    count: number;
    confirm: boolean;
  }>(handleApiError);
};

export const confirmSubscribeByCode = (code: string) => {
  return post('/ajax/users/subscribes/check_code.php', { code }).then<{ success: boolean }>(
    handleApiError,
  );
};

export const addSubscribes = (data: { email: string; regions: number[]; types: number[] }) => {
  return post('/ajax/users/subscribes/add.php', data).then<{ id: number }>(handleApiError);
};

export const requestConfirmSubscribe = (id_subscribe: number) => {
  return post('/ajax/users/subscribes/confirm.php', { id: id_subscribe }).then<{
    success: boolean;
  }>(handleApiError);
};

export const toggleUserSubscribe = (id: number, on: boolean) => {
  return post('/ajax/users/subscribes/toggle.php', { id, value: on ? 1 : 0 }).then<{
    success: boolean;
  }>(handleApiError);
};
